import * as Yup from 'yup';

const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/;
const today = new Date();
today.setHours(23, 59, 59, 999);

function parseDate(value) {
  if (!value) return null;
  const parts = value.split('.');
  if (parts.length !== 3) return null;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  return new Date(year, month - 1, day);
}

export const ocrFormSchema = Yup.object().shape({
  first_name: Yup.string().required('onboarding_personal_form_required'),
  last_name: Yup.string().required('onboarding_personal_form_required'),
  birth_name: Yup.string().nullable(),
  birth_date: Yup.string()
    .required('onboarding_personal_form_required')
    .matches(dateRegex, 'ocr_validation_date_format')
    .test('valid-date', 'ocr_validation_birth_date_future', value => {
      const date = parseDate(value);
      return !date || date <= today;
    }),
  birth_place: Yup.string().required('onboarding_personal_form_required'),
  personal_identification_number: Yup.string().required('onboarding_personal_form_required'),
  sex: Yup.string()
    .required('onboarding_personal_form_required')
    .oneOf(['M', 'F'], 'ocr_validation_sex_invalid'),
  nationality: Yup.string()
    .required('onboarding_personal_form_required')
    .test('is-svk', 'ocr_validation_nationality_svk', value => {
      if (!value) return true; // nechaj required chybu, ak je prázdne
      return value === 'SVK';
    }),
  address: Yup.string().required('onboarding_personal_form_required'),
  indicative_number: Yup.string().required('onboarding_personal_form_required'),
  statement_number: Yup.string().nullable(),
  city: Yup.string().required('onboarding_personal_form_required'),
  postal_code: Yup.string().required('onboarding_personal_form_required'),
  document_number: Yup.string().required('onboarding_personal_form_required'),
  issue_date: Yup.string()
    .required('onboarding_personal_form_required')
    .matches(dateRegex, 'ocr_validation_date_format')
    .test('valid-date', 'ocr_validation_issue_date_future', value => {
      const date = parseDate(value);
      return !date || date <= today;
    }),
  expiry_date: Yup.string()
    .required('onboarding_personal_form_required')
    .matches(dateRegex, 'ocr_validation_date_format')
    .test('valid-date', 'ocr_validation_expiry_date_past', value => {
      const date = parseDate(value);
      return !date || date > today;
    }),
  issued_by: Yup.string().required('onboarding_personal_form_required'),
  special_remarks: Yup.string().nullable(),
  contact_address: Yup.string().when('has_different_contact_address', {
    is: true,
    then: Yup.string().required('onboarding_personal_form_required'),
    otherwise: Yup.string().nullable(),
  }),
  contact_indicative_number: Yup.string().when('has_different_contact_address', {
    is: true,
    then: Yup.string().required('onboarding_personal_form_required'),
    otherwise: Yup.string().nullable(),
  }),
  contact_statement_number: Yup.string().nullable(),
  contact_city: Yup.string().when('has_different_contact_address', {
    is: true,
    then: Yup.string().required('onboarding_personal_form_required'),
    otherwise: Yup.string().nullable(),
  }),
  contact_postal_code: Yup.string().when('has_different_contact_address', {
    is: true,
    then: Yup.string().required('onboarding_personal_form_required'),
    otherwise: Yup.string().nullable(),
  }),
  has_different_contact_address: Yup.boolean(),
});
